import * as customerPermissionsActions from '../session/customer-permissions/customer-permissions.actions';
import * as customerInfoActions from '../customer-info/customer-info.actions';
import * as actions from './blank-receipts.actions';
import { BlankReceipt } from './blank-receipts.interface';
import { BLANK_RECEIPTS_INITIAL_STATE } from './blank-receipts.model';

type Actions = actions.Actions | customerPermissionsActions.Actions | customerInfoActions.Actions;

export function reducer(state = BLANK_RECEIPTS_INITIAL_STATE, action: Actions): BlankReceipt {
  switch (action.type) {
    case actions.BLANK_RECEIPT_CREATE: {
      return {
        ...state,
        saving: true,
        request: action.payload.request,
      };
    }

    case actions.BLANK_RECEIPT_CREATE_FAIL:
    case actions.BLANK_RECEIPT_CREATE_SUCCESS: {
      return {
        ...state,
        saving: false,
        request: null,
      };
    }

    case actions.BLANK_RECEIPT_LOCATION_SUCCESS: {
      return {
        ...state,
        shipTos: action.payload.shipTos,
      };
    }

    default: {
      return state;
    }
  }
}
